'use client';

import { useState, useRef, useEffect } from 'react';
import { api } from '@/lib/apiClient';
import Cookies from 'js-cookie';

export default function InterestedPopup({ isOpen, onClose, loggedInPerson, listingId, mode, phone, agentName, searchData }) {
    const [step, setStep] = useState(1);
    const [otp, setOtp] = useState('');
    const [userId, setUserId] = useState('');
    const [formData, setFormData] = useState({
        mobile: '',
        name: '',
        email: '',
        city: '',
        message: ''
    });

    const [otpValues, setOtpValues] = useState(['', '', '', '']);
    const otpRefs = useRef([]);

    useEffect(() => {
        const init = async () => {
            console.log("loggedInPerson", loggedInPerson);
            if (isOpen) {
                if (loggedInPerson) {
                    var user = Cookies.get('id');
                    if (!user) {
                        return;
                    }
                    user = user.replace(/^"|"$/g, '');
                    setUserId(user);
                    updateListingStatus(user);
                    setStep(4);
                } else {
                    setStep(1);
                }
                // Reset state
                setFormData({
                    mobile: '',
                    name: '',
                    email: '',
                    city: '',
                });
                setOtpValues(['', '', '', '']);
            }
        };
        init();
    }, [isOpen, loggedInPerson]);

    const updateListingStatus = async (uid) => {
        const effectiveUserId = uid || userId;
        console.log("updateListingStatus", mode);
        try {
            if (mode === 'listing' || mode === 'rent') {
                console.log("user", effectiveUserId);
                console.log("listingId", listingId);
                const response = await api.post('insertwithout/enquiries', {
                    listing_id: listingId,
                    user_id: effectiveUserId,
                    enquiry_type: 'listing',
                });
                if (response.success === 1) {
                    if (mode === 'listing') {
                        await api.post('insertwithout/saved_search', {
                            search_history: searchData,
                            user_id: effectiveUserId,
                            listing_id: listingId,
                        });
                    }
                    console.log("Listing status updated successfully");
                }
                else {
                    console.log(response.msg);
                }
            }
            else if (mode === 'project') {
                const response = await api.post('insertwithout/enquiries', {
                    project_id: listingId,
                    user_id: effectiveUserId,
                    enquiry_type: 'project',
                });
                if (response.success === 1) {
                    await api.post('insertwithout/saved_search', {
                        search_history: searchData,
                        user_id: effectiveUserId,
                        project_id: listingId,
                    });
                    console.log("Project status updated successfully");
                }
                else {
                    console.log(response.msg);
                }
            }
        } catch (error) {
            console.error(error);
        }
    }

    const handleMobileChange = (e) => {
        const val = e.target.value.replace(/\D/g, '').slice(0, 10);
        setFormData({ ...formData, mobile: val });
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleMobileSubmit = async (e) => {
        e.preventDefault();
        if (formData.mobile.length === 10) {
            const response = await api.post('getotp', { mobile: formData.mobile });

            if (response.success === 1) {
                setOtp(response.otp);
                console.log("otp", response.otp);
                setStep(2);
            }
            // else if (response.success === 2) {
            //     const expiresIn = response.expiresIn || 3600;

            //     const cookieOptions = {
            //         secure: process.env.NODE_ENV === 'production',
            //         sameSite: 'strict',
            //         expires: new Date(Date.now() + expiresIn * 1000),
            //         path: '/',
            //     };
            //     setUserId(response.id);
            //     Cookies.set('token', response.token, cookieOptions);
            //     Cookies.set('name', JSON.stringify(response.name), cookieOptions);
            //     Cookies.set('id', JSON.stringify(response.id), cookieOptions);
            //     Cookies.set('mobile', JSON.stringify(response.mobile), cookieOptions);
            //     Cookies.set('role', JSON.stringify(response.userrole), cookieOptions);
            //     updateListingStatus();
            //     setStep(4);
            // }
            else {
                console.log(response.msg);
            }

        } else {
            alert('Please enter a valid 10-digit mobile number.');
        }
    };

    const handleOtpChange = (index, value) => {
        const val = value.replace(/\D/g, '').slice(0, 1);
        const newOtp = [...otpValues];
        newOtp[index] = val;
        setOtpValues(newOtp);

        // Auto jump to next input
        if (val && index < 3) {
            otpRefs.current[index + 1].focus();
        }
    };

    const handleOtpKeyDown = (index, e) => {
        if (e.key === 'Backspace' && !otpValues[index] && index > 0) {
            otpRefs.current[index - 1].focus();
        }
    };

    const handleOtpSubmit = async (e) => {
        e.preventDefault();
        const otpStr = otpValues.join('');
        if (otpStr.length === 4) {
            if (otpStr === otp) {
                const response = await api.post('userregotp', { mobile: formData.mobile });
                console.log("response", response);
                if (response.success === 1) {
                    // setOtp(response.otp);
                    // console.log("otp", response.otp);
                    setStep(3);
                }
                else if (response.success === 2) {
                    const expiresIn = response.expiresIn || 3600;

                    const cookieOptions = {
                        secure: process.env.NODE_ENV === 'production',
                        sameSite: 'strict',
                        expires: new Date(Date.now() + expiresIn * 1000),
                        path: '/',
                    };
                    setUserId(response.id);
                    console.log("updated userId", response.id);
                    Cookies.set('token', response.token, cookieOptions);
                    Cookies.set('name', JSON.stringify(response.name), cookieOptions);
                    Cookies.set('id', JSON.stringify(response.id), cookieOptions);
                    Cookies.set('mobile', JSON.stringify(response.mobile), cookieOptions);
                    Cookies.set('role', JSON.stringify(response.userrole), cookieOptions);
                    updateListingStatus(response.id);
                    setStep(4);
                }
                else {
                    console.log(response.msg);
                }
                // setStep(3);
            } else {
                alert('Please enter a valid 4-digit OTP.');
            }
        } else {
            alert('Please enter a valid 4-digit OTP.');
        }
    };

    const handleFinalSubmit = async (e) => {
        e.preventDefault();
        // Here you would send final data to API

        try {
            const response = await api.post('insertwithout/users', {
                mobile: formData.mobile,
                full_name: formData.name,
                email: formData.email,
                user_role: 'buyer',
                is_verified: 1,
                mobile_verified: 1,
                city: formData.city,
                //  otp_id: otpId // Include OTP ID for verification
            });

            if (response.success === 1) {
                // Auto-login after registration
                var insid = response.insId;
                const response2 = await api.post('checklogin', { mobile: formData.mobile });

                if (response2.success === 1) {
                    const expiresIn = response2.expiresIn || 3600;
                    setUserId(response2.id);
                    updateListingStatus(response2.id);
                    const cookieOptions = {
                        secure: process.env.NODE_ENV === 'production',
                        sameSite: 'strict',
                        expires: new Date(Date.now() + expiresIn * 1000),
                        path: '/',
                    };

                    Cookies.set('token', response2.token, cookieOptions);
                    Cookies.set('name', JSON.stringify(response2.name), cookieOptions);
                    Cookies.set('id', JSON.stringify(response2.id), cookieOptions);
                    Cookies.set('mobile', JSON.stringify(response2.mobile), cookieOptions);
                    Cookies.set('role', JSON.stringify(response2.userrole), cookieOptions);
                    setStep(4);

                }
            } else {
                setError(response.msg || 'Registration failed');
            }
        } catch (error) {
            console.error(error);
            setError('Registration failed. Please try again.');
        } finally {
            // setIsLoading(false);
        }


    };

    if (!isOpen) return null;

    const handleClose = () => {
        if (onClose) onClose();
    };

    // const property = {
    //     agent: {
    //         name: "John Doe",
    //         mobile: "9876543210"
    //     },
    //     costs: {
    //         rent: 25000,
    //         deposit: 300000
    //     }
    // };

    return (
        <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-black/50 backdrop-blur-sm">
            <div className="bg-white rounded-2xl p-10 w-[90%] max-w-sm animate-scaleIn relative">
                {step !== 4 && (
                    <button
                        onClick={handleClose}
                        className="absolute top-4 right-4 text-gray-500 hover:text-gray-800 text-2xl leading-none"
                        aria-label="Close"
                    >
                        &times;
                    </button>
                )}

                {step !== 4 && <h2 className="text-xl font-bold mb-4 text-center">I'm Interested</h2>}

                {step === 1 && (
                    <form onSubmit={handleMobileSubmit} className="flex flex-col gap-4">
                        <div className="flex flex-col gap-3">
                            <label className="block text-sm font-medium text-gray-700 mb-1">Mobile Number</label>
                            <input
                                type="text"
                                name="mobile"
                                value={formData.mobile}
                                onChange={handleMobileChange}
                                placeholder="Enter 10-digit mobile number"
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary outline-none transition-all"
                                required
                            />
                        </div>
                        <button type="submit" className="w-full mt-2 btn btn-primary bg-primary text-white py-2.5 text-base font-bold shadow-primary/30 shadow-md rounded-lg hover:opacity-90">
                            Next
                        </button>
                    </form>
                )}

                {step === 2 && (
                    <form onSubmit={handleOtpSubmit} className="flex flex-col gap-4">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2 text-center">Enter OTP sent to +91 {formData.mobile}</label>
                            <div className="flex justify-center gap-3 mb-2">
                                {otpValues.map((digit, index) => (
                                    <input
                                        key={index}
                                        ref={(el) => (otpRefs.current[index] = el)}
                                        type="text"
                                        maxLength={1}
                                        value={digit}
                                        onChange={(e) => handleOtpChange(index, e.target.value)}
                                        onKeyDown={(e) => handleOtpKeyDown(index, e)}
                                        className="w-12 h-12 text-center text-xl font-bold border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary outline-none transition-all"
                                        required
                                    />
                                ))}
                            </div>
                        </div>
                        <button type="submit" className="w-full btn btn-primary bg-primary text-white py-2.5 text-base font-bold shadow-primary/30 shadow-md rounded-lg hover:opacity-90">
                            Go
                        </button>
                    </form>
                )}

                {step === 3 && (
                    <form onSubmit={handleFinalSubmit} className="flex flex-col gap-4">
                        <div className="bg-primary/10 text-primary py-2 px-4 rounded-lg text-center font-semibold mb-2">
                            Mobile: +91 {formData.mobile}
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Name <span className="text-red-500">*</span></label>
                            <input
                                type="text"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                placeholder="Enter full name"
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary outline-none transition-all"
                                required
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Email ID <span className="text-red-500">*</span></label>
                            <input
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                placeholder="Enter email address"
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary outline-none transition-all"
                                required
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">City <span className="text-red-500">*</span></label>
                            <input
                                type="text"
                                name="city"
                                value={formData.city}
                                onChange={handleChange}
                                placeholder="Enter city"
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary outline-none transition-all"
                                required
                            />
                        </div>
                        <button type="submit" className="w-full btn btn-primary bg-primary text-white py-2.5 text-base font-bold shadow-primary/30 shadow-md rounded-lg hover:opacity-90">
                            Submit
                        </button>
                    </form>
                )}

                {step === 4 && (
                    <div className="text-center">
                        {/* Icon */}
                        <div className="text-green-500 text-5xl mb-3 flex justify-center">✔</div>

                        {/* Title */}
                        <h2 className="text-xl font-bold mb-2">
                            Thank You!
                        </h2>

                        {/* Message */}
                        <div className="bg-white relative overflow-hidden">
                            {/* <h2 className="text-xl font-medium text-left mb-1">
                                Anbu illam,
                            </h2>
                            <p className="text-sm text-gray-500 text-left mb-5">
                                #27, Merku Mambalam, Chennai - 600033
                            </p>
                            <div className="flex justify-between items-end mb-6">
                                <div>
                                    <p className="text-gray-500 text-sm font-medium">Monthly Rent</p>
                                    <h3 className="text-2xl font-bold text-gray-900">₹{property.costs.rent != null ? property.costs.rent.toLocaleString() : 'N/A'}</h3>
                                </div>
                                <div className="text-right">
                                    <span className="text-sm text-gray-500 block">Deposit</span>
                                    <span className="font-semibold text-gray-800">{property.costs.deposit != null ? `₹${(property.costs.deposit / 100000).toFixed(1)} Lac` : 'N/A'}</span>
                                </div>
                            </div> */}
                            <div className="flex items-center gap-4 mb-6">
                                <div className="w-10 h-10 bg-gradient-to-br from-gray-700 to-gray-900 rounded-full flex items-center justify-center text-white text-lg font-bold shadow-md">
                                    {agentName.charAt(0)}
                                </div>
                                <div>
                                    <h5 className="font-bold text-gray-900">{agentName}</h5>
                                    <p className="text-sm text-gray-500">{phone}</p>
                                </div>
                            </div>
                        </div>

                        {/* Button */}
                        <button
                            onClick={handleClose}
                            className="bg-primary text-white px-6 py-2 rounded-lg font-semibold hover:opacity-90"
                        >
                            OK
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
}

